import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconVisibilityOffComponent } from "./med-icon-visibility-off.component";

@NgModule({
  declarations: [
    MedIconVisibilityOffComponent,
  ],
  imports: [CommonModule],
  exports: [MedIconVisibilityOffComponent],
})
export class MedIconVisibilityOffModule { }
